import qz from "qz-tray";
import QzTrayClientSignerService from "./QzTrayClientSignerService";
import QzTrayPublicCertificateService from "./QzTrayPublicCertificateService";

const SIGNATURE_ALGORITHM = "SHA256";

const getCertificate = async (): Promise<string> => {
  const response = await QzTrayPublicCertificateService.getPublicCertificate();
  const certificate = response?.data;

  if (response?.statusCode !== 200 || typeof certificate !== "string" || !certificate.trim()) {
    throw new Error("El backend no devolvió un certificado público QZ Tray válido.");
  }

  return certificate.trim();
};

const sign = async (toSign: string): Promise<string> => {
  const response = await QzTrayClientSignerService.signRaw(toSign);
  const signature = response?.data?.signature;

  if (response?.statusCode !== 200 || typeof signature !== "string" || !signature.trim()) {
    throw new Error(response?.message || "El backend no devolvió una firma QZ Tray válida.");
  }

  return signature.trim();
};

/** Configura la identidad y la firma antes de cualquier llamada a QZ Tray. */
const configure = () => {
  qz.security.setSignatureAlgorithm(SIGNATURE_ALGORITHM);
  qz.security.setCertificatePromise(getCertificate, { rejectOnFailure: true });
  qz.security.setSignaturePromise(sign);
};

const QzTraySecurityService = { configure, getCertificate, sign };

export default QzTraySecurityService;
